(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.directives')
		.directive('footer', Footer)

	/** @ngInject */
	function Footer(PATHS) {
		function FooterController($scope, APP) {
			const vm = this;

			function checkLgpdLocalStorage() {
				if (localStorage.getItem(`showLgpd${APP.IDENTIFIER}`))
					return localStorage.getItem(`showLgpd${APP.IDENTIFIER}`);

				return true;
			}

			function saveLgpdLocalStorage(showLgpd) {
				if (localStorage.getItem(`showLgpd${APP.IDENTIFIER}`))
					localStorage.removeItem(`showLgpd${APP.IDENTIFIER}`)

				localStorage.setItem(`showLgpd${APP.IDENTIFIER}`, JSON.stringify(showLgpd))
			}

			vm.acceptPrivacy = () => {
				vm.showLgpdModal = false;
				saveLgpdLocalStorage(false);
			}

			vm.openWhatsapp = () => window.open('https://api.whatsapp.com/send?phone=5519991467441', '_blank');

			init();

			function init() {
				vm.showLgpdModal = checkLgpdLocalStorage();
			}

		}

		return {
			bindToController: true,
			controller: FooterController,
			controllerAs: 'vm',
			restrict: 'AE',
			templateUrl: `${PATHS.PHYSICAL}/directives/footer/footer.html`,
			scope: {}
		}
	}
}());